import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { Nullable } from '@/utils/types';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { getIsSuperAdmin } from '@/bundles/App/helpers/getIsSuperAdmin';

export const getShowArchiveFilterConfig = (): Nullable<IFilterConfigItem> => {
  return getIsSuperAdmin() ? {
    title: 'Show Archive',
    name: 'show_inactive',
    type: FilterTypeEnum.switch,
    category: FilterCategoryEnum.universal,
  } : null;
}
